{
  "clubId": "club-user",
  "capacity": 45000,
  "standsLevel": 2,
  "parkingLevel": 1,
  "cafeteriaLevel": 2,
  "merchandisingLevel": 1,
  "bathroomLevel": 1,
  "condition": 92,
  "maintenanceCost": 120000,
  "ticketPrice": 45,
  "seasonTicketPrice": 450,
  "ratingLevel": 1.5,
  "facilitiesRatingLevel": 1.5,
  "createdAt": "2026-08-01T00:00:00Z",
  "updatedAt": "2026-09-20T00:00:00Z",
  "version": 1
}
